<!-- eslint-disable vue/prop-name-casing -->
<script setup>
import { useModal } from 'vue-final-modal';
import TransmittalWorkflowBlockEditPopup from '~/dms/components/transmittals/workflow/graph/transmittal-workflow-block-edit-popup.vue';

const props = defineProps({
  step: {
    type: Object,
    default: () => ({}),
  },
  visible_options: {
    type: Object,
  },
  published: {
    type: Boolean,
  },
  disabled: {
    type: Boolean,
  },
  is_final: {
    type: Boolean,
  },
  is_last_step: {
    type: Boolean,
  },
  allow_assignee_edit: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['delete', 'update:custom_field_mapping']);
const step = computed(() => props.step);
const sub_steps = computed(() => props.step.sub_steps);

const existing_members_in_workflow = inject('existing_members_in_workflow');

function addSubSteps() {
  const { open: openEditModal, close: closeEditModal } = useModal({
    component: TransmittalWorkflowBlockEditPopup,
    attrs: {
      is_sub_step: true,
      step: props.step,
      existing_members: existing_members_in_workflow,
      onClose() {
        closeEditModal();
      },
      async submit(data, _step) {
        sub_steps.value.push({ ...data, sub_index: sub_steps.value.length });
        emit('update:custom_field_mapping', _step?.custom_field_mapping);
        closeEditModal();
      },
    },
  });
  openEditModal();
}

const removeSubSteps = index => sub_steps.value.length === 1 ? emit('delete') : sub_steps.value.splice(index, 1);
</script>

<template>
  <div class="flex group">
    <div class="relative">
      <div class="bg-white w-[345px] min-h-[150px] border border border-gray-200 rounded-xl p-2">
        <div class="flex justify-between">
          <div class="w-[142px] flex items-center">
            <select v-model="step.condition" :disabled="published || disabled" class=" bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
              <option
                v-for="option in [{ label: 'ALL', value: 'AND' },
                                  { label: 'ANY', value: 'OR' }]"
                :key="option.value" :value="option.value"
              >
                {{ option.label }}
              </option>
            </select>
            <IconHawkInfoCircle v-tippy="$t('No. members to respond')" class="ml-2 w-8 h-8 pointer-events-auto" />
          </div>
          <div class="flex">
            <div :class="!published ? 'rounded-lg border border-gray-300 p-2 shadow-xs mr-2 cursor-pointer' : 'p-2 mr-2 pointer-events-none'" @click="step.on_reject = step.on_reject === 'continue' ? 'revert' : 'continue'">
              <IconHawkArrowRight v-if="step.on_reject === 'continue'" v-tippy="$t('Move to next step')" class="pointer-events-auto" />
              <IconHawkFlipBackward v-else v-tippy="$t('Rollback to initiator on rejection / resubmission')" class="text-error-600 pointer-events-auto" />
            </div>
            <div class="relative w-[102px]">
              <input v-model.number="step.duration" :disabled="disabled" type="number" class=" border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 pr-12" required="">
              <div class="absolute right-3 top-2">
                days
              </div>
            </div>
          </div>
        </div>
        <transmittal-workflow-graph-step-block
          v-for="(sub_step, index) in step.sub_steps"
          :key="sub_step"
          :step="step"
          :sub_step="sub_step"
          :is_final="is_final"
          :is_last_step="is_last_step"
          :published="published"
          :disabled="disabled"
          :allow_assignee_edit="allow_assignee_edit"
          :visible_options="visible_options" @delete="removeSubSteps(index)"
          @update-substep="sub_step => step.sub_steps[index] = sub_step"
          @update:custom_field_mapping="emit('update:custom_field_mapping', $event)"
        />
      </div>
      <div v-if="!published && !step?.sub_steps?.[0]?.stamp?.is_enabled" class=" !absolute right-14 -bottom-2  cursor-pointer invisible group-hover:visible  bg-gray-50" @click="addSubSteps">
        <IconHawkPlusCircle class="w-[24px] h-[24px]" />
      </div>
    </div>
  </div>
</template>

<style scoped>
select {
    background-position: right 0.75rem center;
    background-repeat: no-repeat;
    background-size: 0.75em 0.75em;
    padding-right: 2.5rem;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg aria-hidden='true' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 10 6'%3E%3Cpath stroke='%236B7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m1 1 4 4 4-4'/%3E%3C/svg%3E");
}
</style>
